<div #wrapper class="wrapper">
  <img class="image" draggable="false" [src]="wasOnceVisible ? src : ''">
</div>
